import configService from './configService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://oauth.remote-assistant.ai';

class FAQService {
  async listSources() {
    const token = await configService.getAuthToken();
    const response = await fetch(`${API_BASE_URL}/oauth/faq/sources`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to load FAQ sources (${response.status})`);
    }

    return await response.json();
  }

  async addSource(sourceUrl) {
    const token = await configService.getAuthToken();
    const response = await fetch(`${API_BASE_URL}/oauth/faq/sources`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ source_url: sourceUrl })
    });

    if (!response.ok) {
      throw new Error(`Failed to add FAQ source (${response.status})`);
    }

    return await response.json();
  }

  async deleteSource(sourceUrl) {
    const token = await configService.getAuthToken();
    const response = await fetch(`${API_BASE_URL}/oauth/faq/sources`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ source_url: sourceUrl })
    });

    if (!response.ok) {
      throw new Error(`Failed to delete FAQ source (${response.status})`);
    }

    return await response.json();
  }

  async regenerate() {
    const token = await configService.getAuthToken();
    const response = await fetch(`${API_BASE_URL}/oauth/faq/regenerate`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to regenerate FAQ (${response.status})`);
    }

    return await response.json();
  }

  async search(question, k = 3) {
    const token = await configService.getAuthToken();
    const response = await fetch(`${API_BASE_URL}/oauth/faq/search`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ question, k })
    });

    if (!response.ok) {
      throw new Error(`Failed to search FAQ (${response.status})`);
    }

    return await response.json();
  }

  async chat(question, k = 3) {
    const token = await configService.getAuthToken();
    const response = await fetch(`${API_BASE_URL}/oauth/faq/chat`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ question, k })
    });

    if (!response.ok) {
      throw new Error(`Failed to chat with FAQ (${response.status})`);
    }

    return await response.json();
  }
}

export const faqService = new FAQService();
export default faqService;
